import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { operationalFunction, getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';
import { message } from 'antd';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//打开Report界面
export function showReportDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/Report/GetReportConfig/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ showModal: true, report: data.data });

        //获取组件数据源
        let componentDataSource = [];
        let parameter = [];
        parameter.push({ key: 'moduleId', value: pageComponent.state.defaultFormData.moduleId });
        pageComponent.state.report.ReportConfig.parameters.uieList.map(async (uie, j) => {
          getUieDataSource({ parameter: parameter, sectionName: 'Report', component: pageComponent, sectionComponent: pageComponent, pageComponent: pageComponent, uie: uie });
        })

      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
